import React from "react";

export const TextArea = ({ className = "", title, validState, errorMessage, ...props }) => {
    return (
        <div className={`input-field ${props.disabled && "disabled"} text-area-container`}>
            <label htmlFor={props.id} className={`input-field__label`}>
                {title}
            </label>
            {validState === "invalid" ? (
                <span className="input-field__error paragraph-small">{errorMessage}</span>
            ) : null}
            <textarea {...props} className={`input-field__input ${validState} ${className}`} />
        </div>
    );
};
